const CART_DRAWER_SHIPPING_PROGRESS_KEY = 'cartDrawerShippingProgress';

function animateCartDrawerShippingBar(root) {
  const scope = root && root.querySelector ? root : document;
  scope.querySelectorAll('.cart-drawer__shipping-bar').forEach((bar) => {
    const fill = bar.querySelector('.cart-drawer__shipping-bar-fill');
    if (!fill) return;

    const targetPercent = parseFloat(fill.dataset.progress) || 0;
    const target = Math.min(1, targetPercent / 100);
    const stored = sessionStorage.getItem(CART_DRAWER_SHIPPING_PROGRESS_KEY);
    const start = stored !== null ? Math.min(1, parseFloat(stored) / 100) : 0;

    fill.style.setProperty('--progress-ratio', start);
    fill.style.transition = 'none';
    fill.offsetWidth;
    fill.style.transition = '';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.setProperty('--progress-ratio', target);
        sessionStorage.setItem(CART_DRAWER_SHIPPING_PROGRESS_KEY, String(targetPercent));
      });
    });
  });
}

function clearCartDrawerShippingProgress() {
  sessionStorage.removeItem(CART_DRAWER_SHIPPING_PROGRESS_KEY);
}

window.animateCartDrawerShippingBar = animateCartDrawerShippingBar;
window.clearCartDrawerShippingProgress = clearCartDrawerShippingProgress;

document.addEventListener('DOMContentLoaded', () => {
  animateCartDrawerShippingBar();
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    requestAnimationFrame(() => animateCartDrawerShippingBar());
  });
}
